// Las respuestas anteriores a fase 6 pueden omitir status, client_name y total.
// C5: al cambiar de cliente solo se valida el cliente; una locación ya asignada
// se conserva aunque después se haya desactivado.
export const isClientCompatible = (location, clientId) =>
  !location.client_id || location.client_id === clientId;

export const isAvailableLocation = (location, clientId) =>
  (!location.status || location.status === 'activa') &&
  (!location.client_id || location.client_id === clientId);

export const locationClientLabel = (location, clients = []) => {
  if (!Object.prototype.hasOwnProperty.call(location, 'client_id')) return 'Cliente no informado';
  if (!location.client_id) return 'Venue compartido';
  const name = location.client_name || location.client?.name ||
    clients.find(client => client.id === location.client_id)?.name;
  return typeof name === 'string' && name.trim() ? name : 'Cliente asignado';
};

export const matchesLocationSearch = (location, query) => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const address = typeof location.address === 'string' ? location.address :
    Object.values(location.address || {}).filter(value => typeof value === 'string').join(' ');
  return normalize(`${location.name || ''} ${address}`).includes(normalize(query).trim());
};

// El listado anterior sí contiene client_id; /search lo proyectaba fuera.
export async function loadLocationOptions(list, isCurrent = () => true) {
  const items = [];
  let skip = 0;
  while (isCurrent()) {
    const response = await list({ status: 'activa', limit: 1000, ...(skip ? { skip } : {}) });
    const page = response.data.items || [];
    items.push(...page);
    skip += page.length;
    if (!page.length || !response.data.total || skip >= response.data.total) break;
  }
  return items;
}
